
var ConnectionActivityMonitor = require('./connection-activity-monitor');

var pingTimeoutFactor = 2;

var noop = {
    onSystemPing: function () {},
    shutdown: function () {}
};

/**
 * Factory for connection activity monitors.
 * @param connection The connection to be monitored
 * @param response The new connection response
 */
function connectionActivityMonitorFactory(connection, response) {
    if (response.systemPingPeriod > 0) {
        var pingTimeout = response.systemPingPeriod * pingTimeoutFactor;
        return new ConnectionActivityMonitor(pingTimeout, connection);
    }
    else {
        return noop;
    }
}

module.exports = connectionActivityMonitorFactory;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/activity/connection-activity-monitor-factory.js
// module id = 948
// module chunks = 1